import { render, staticRenderFns } from "./DealerRegistrationAndService.vue?vue&type=template&id=21ef2522&scoped=true"
import script from "./DealerRegistrationAndService.vue?vue&type=script&lang=js"
export * from "./DealerRegistrationAndService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef2522",
  null
  
)

export default component.exports